import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, of } from "rxjs";
import { tap, catchError } from 'rxjs/operators';
import { ChartDataModel, HompageTankDataModel } from "src/app/models/homepageData/chartData.model";
import { KpiDataModel } from "src/app/models/homepageData/kpiData.model";


@Injectable({
    providedIn: 'root'
})
export class HomepageDataService {

    private ADMIN_CHART_DATA_URL = 'api/homepageData/GetAdminChartData'
    private ADMIN_KPI_DATA_URL = 'api/homepageData/GetAdminKPIData'
    private DIST_CHART_DATA_URL = 'api/homepageData/GetDistributorChartData/'
    private DIST_KPI_DATA_URL = 'api/homepageData/GetDistributorKPIData/'
    private DIST_CHECK_METERED_Billing_URL = 'api/homepageData/CheckMeteredBilling/'
    private HP_TANKS_DATA = 'api/homepageData/GetHomepageTanks/'

    constructor(
        private _httpClient: HttpClient
    ) {
    }

    getAdminChartData$(): Observable<ChartDataModel> {
        let chartData = this._httpClient.get<ChartDataModel>(`${this.ADMIN_CHART_DATA_URL}`);
        return chartData;
    }

    getAdminKPIData$(): Observable<KpiDataModel> {
        let kpiData = this._httpClient.get<KpiDataModel>(`${this.ADMIN_KPI_DATA_URL}`);
        return kpiData;
    }
   
    getChartData$(id: number): Observable<ChartDataModel> {
        let chartData = this._httpClient.get<ChartDataModel>(`${this.DIST_CHART_DATA_URL}${id}`);
        return chartData;
    }

    getKPIData$(id: number): Observable<KpiDataModel> {
        let kpiData = this._httpClient.get<KpiDataModel>(`${this.DIST_KPI_DATA_URL}${id}`);
        return kpiData;
    }

    checkMeteredBilling$(id: number): Observable<boolean> {
        let hasMeteredTanks = this._httpClient.get<boolean>(`${this.DIST_CHECK_METERED_Billing_URL}${id}`);
        return hasMeteredTanks;
    }

    getHomepageTanks$(id: number): Observable<HompageTankDataModel> {
        let homeTanksData = this._httpClient.get<HompageTankDataModel>(`${this.HP_TANKS_DATA}${id}`);
        return homeTanksData;
    }

}

